import { Controller } from "@hotwired/stimulus"

// Live monthly-fee preview for a Back Office (AP/AR) quote row: recalculates
// the Total cell as the rep types the monthly invoice/bill counts. Mirrors
// Sales::PricingCalculator#back_office_fee — each of AR (invoices) and AP
// (bills) is base + count × rate × 100 rounded to the nearest $25, and $0 when
// its count is zero. The server-side calculator on save stays the source of
// truth; this only previews the number before the row is saved.
export default class extends Controller {
  static targets = ["invoices", "bills", "total"]
  static values = { base: Number, invoiceRate: Number, billRate: Number }

  recalc() {
    const total = this.fee(this.invoicesTarget.value, this.invoiceRateValue) +
                  this.fee(this.billsTarget.value, this.billRateValue)
    this.totalTarget.textContent = `$${total.toLocaleString()}/Monthly`
  }

  fee(rawCount, rate) {
    const count = parseFloat(rawCount)
    if (!count || count <= 0) return 0
    return this.mround(this.baseValue + count * rate * 100, 25)
  }

  mround(value, multiple) {
    return Math.round(value / multiple) * multiple
  }
}
